import React from "react";
import PropTypes from "prop-types";
import { isInchesUnit } from "../../../utils/height";
import FeetInchesInput from "./FeetInchesInput";
import SingleHeightInput from "./SingleHeightInput";
import useHeightInputConfig from "./useHeightInputConfig";

function HeightInput({
  market,
  name,
  value,
  onChange,
  unit,
  isShortUnit = false,
  labelClassName = "",
  errorClassName = "",
  fieldsetWrapperClassName = "",
  capitalizeLabel = false
}) {
  const isInches = isInchesUnit(unit);
  const { label, ...others } = useHeightInputConfig(unit);
  const props = {
    market,
    name,
    unit,
    mask: others.mask,
    label,
    value,
    onChange,
    min: others.min,
    max: others.max,
    labelClassName,
    errorClassName,
    fieldsetWrapperClassName,
    capitalizeLabel,
    isShortUnit
  };

  return (
    <>
      {isInches ? (
        <FeetInchesInput {...props} />
      ) : (
        <SingleHeightInput {...props} />
      )}
    </>
  );
}

HeightInput.propTypes = {
  name: PropTypes.string.isRequired,
  market: PropTypes.string.isRequired,
  unit: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  min: PropTypes.oneOf([PropTypes.number, PropTypes.object]),
  max: PropTypes.oneOf([PropTypes.number, PropTypes.object])
};

export default HeightInput;
